/**
 * `tex` — tagged template literal that returns the raw LaTeX source so
 * authoring math inside JSX does not require sprinkling `String.raw`
 * across every backslash.
 *
 * Usage:
 *
 * ```tsx
 * <MathInline>{tex`F \dashv G`}</MathInline>
 * <MathBlock>{tex`\mu \circ T \eta = \mathrm{id}_{T}`}</MathBlock>
 * ```
 *
 * Interpolations are restricted to `string | number` and are inserted
 * between the literal segments verbatim — the LaTeX engine sees exactly
 * what the source line shows, with no JavaScript escape-sequence
 * interpretation eating the leading backslash of `\eta`, `\mu`, etc.
 * Anything other than a string or number is a compile-time error; if
 * the caller needs to interpolate a richer value, they should explicitly
 * format it first (e.g. `tex`T_{\mathrm{${grade.id}}}``).
 *
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 Invariant Holdings LLC
 */

export type TexFragment = string | number;

export function tex(strings: TemplateStringsArray, ...values: readonly TexFragment[]): string {
  return String.raw({ raw: strings }, ...values);
}
